<div class="container">
  <div class="settings-section">
    <svg class="content-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#3498db" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
      <line x1="3" y1="9" x2="21" y2="9"></line>
      <line x1="9" y1="21" x2="9" y2="9"></line>
    </svg>
    <h3>Affichage des contenus</h3>
    <form id="contentDisplayForm">
      <div>
        <label for="postSorting">Trier les publications :</label>
        <div class="select-wrapper">
          <select id="postSorting">
            <option value="chronological"><span class="option-icon">🕒</span> Chronologique</option>
            <option value="relevance"><span class="option-icon">🎯</span> Par pertinence</option>
          </select>
        </div>
      </div>
      <button type="submit">Enregistrer</button>
    </form>
  </div>
</div>

<script>
document.getElementById('contentDisplayForm').addEventListener('submit', function(e) {
  e.preventDefault();
  const postSorting = document.getElementById('postSorting').value;

  // Simulate saving the settings
  setTimeout(() => {
    alert(`Paramètres d'affichage enregistrés :\nTri des publications : ${postSorting === 'chronological' ? 'Chronologique' : 'Par pertinence'}`);
  }, 500);
});

// Add some interactivity
const select = document.querySelector('select');
select.addEventListener('focus', () => {
  select.style.transform = 'scale(1.02)';
});
select.addEventListener('blur', () => {
  select.style.transform = 'scale(1)';
});

// Animate the content icon
const contentIcon = document.querySelector('.content-icon');
contentIcon.addEventListener('mouseover', () => {
  contentIcon.style.transform = 'rotate(360deg)';
  contentIcon.style.transition = 'transform 0.8s ease';
});
contentIcon.addEventListener('mouseout', () => {
  contentIcon.style.transform = 'rotate(0deg)';
});

// Add a ripple effect to the button
const button = document.querySelector('button');
button.addEventListener('click', function(e) {
  let ripple = document.createElement('span');
  ripple.classList.add('ripple');
  this.appendChild(ripple);
  let x = e.clientX - e.target.offsetLeft;
  let y = e.clientY - e.target.offsetTop;
  ripple.style.left = `${x}px`;
  ripple.style.top = `${y}px`;
  setTimeout(() => {
    ripple.remove();
  }, 300);
});

// Add ripple effect styles
const style = document.createElement('style');
style.textContent = `
  button {
    position: relative;
    overflow: hidden;
  }
  .ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple 0.6s linear;
    background-color: rgba(255, 255, 255, 0.7);
  }
  @keyframes ripple {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
`;
document.head.appendChild(style);

// Change content icon based on selection
select.addEventListener('change', (e) => {
  const selectedSorting = e.target.value;
  const contentIcon = document.querySelector('.content-icon');
  
  if (selectedSorting === 'chronological') {
    contentIcon.innerHTML = `
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
      <line x1="3" y1="9" x2="21" y2="9"></line>
      <line x1="9" y1="21" x2="9" y2="9"></line>
    `;
  } else {
    contentIcon.innerHTML = `
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
    `;
  }
});

// Add hover effect to select options
const selectElement = document.getElementById('postSorting');
selectElement.addEventListener('mouseover', (event) => {
  if (event.target.tagName === 'OPTION') {
    event.target.style.backgroundColor = 'rgba(108, 92, 231, 0.1)';
  }
});
selectElement.addEventListener('mouseout', (event) => {
  if (event.target.tagName === 'OPTION') {
    event.target.style.backgroundColor = '';
  }
});
</script>